import ApiService from '@/common/api/api.service';

let apiBasePath = 'Estoque';

const EstoqueService = {
    async saidaManual(params) {
        let { data } = await ApiService.put(`${apiBasePath}/saida`, params);
        return data;
    },
    async estorno(estoqueMovimentoId) {
        let { data } = await ApiService.put(
            `${apiBasePath}/estorno?estoqueMovimentoId=${estoqueMovimentoId}`
        );
        return data;
    },
    async ajusteInventario(body) {
        let { data } = await ApiService.put(
            `${apiBasePath}/ajuste-inventario`,
            body
        );
        return data;
    },
    async transferencia(body) {
        let { data } = await ApiService.put(
            `${apiBasePath}/transferencia`,
            body
        );
        return data;
    },
    async obterPorFiltro(parametros) {
        let { data } = await ApiService.get(
            `${apiBasePath}/obter-por-filtro`,  {params: {...parametros}}
        );
        return data;
    },
    async buscaSaldoTotalProduto(params) {
        let { data } = await ApiService.get(
            `${apiBasePath}/obter-total-por-filtro`, { params }
        );
        return data;
    },
    async obterRelatorioEstoque(params) {
        let { data } = await ApiService.get(
            `${apiBasePath}/imprimir-estoque`, { params }
        );
        return data;
    }
};

export default EstoqueService;
